import { copy } from "./shared";
import CheckoutForm from "./CheckoutForm";
import "../templates/Template4.css";
import "./CheckoutTemplate4.css";

export default function CheckoutTemplate4({ data = {}, code }) {
  const c = copy(data);
  return (
    <div className="clp4-root">
      {/* ▓ NAV ▓ */}
      <nav className="nav stuck">
        <div className="w">
          <div className="nav-in">
            <span className="logo">
              {c.logo ? <img src={c.logo} alt="Logo" /> : <span className="cok4-brandtext">{c.brand}</span>}
            </span>
            <span className="cok4-secure">🔒 Secure checkout</span>
          </div>
        </div>
      </nav>

      {/* ▓ HERO ▓ */}
      <section className="hero cok4-hero" id="home">
        <div className="hero-tex"></div>
        <div className="hero-circle"></div>
        <div className="hero-circle2"></div>
        <div className="w" style={{ position: "relative", zIndex: 2 }}>
          <div className="cok4-hero-content">
            <span className="cok4-eyebrow">Checkout</span>
            <h1 className="hero-title">
              Complete your <em>enrollment</em>
            </h1>
            {c.sub ? <p className="hero-subtitle">{c.sub}</p> : null}
          </div>
        </div>
      </section>

      {/* ▓ FORM + SUMMARY ▓ */}
      <div className="w">
        <CheckoutForm data={data} code={code} p="cok4" c={c} />
      </div>

      {/* ▓ FOOTER ▓ */}
      <footer className="footer">
        <div className="w">
          <div className="cok4-foot">{c.guaranteeOn ? c.guarantee : "© " + c.brand}</div>
        </div>
      </footer>
    </div>
  );
}
